import quizJson from '@/components/quiz/quiz.json';
export const CONSTANTS = {
  AUTH: {
    EMAIL_SERVER: 'therapyanimalhub.com',
    EMAIL_FROM: 'noreply@therapyanimalhub.com',
    ADMINS: ['chris@chrisesplin.com', 'wcpringle@gmail.com', 'chris@therapyanimalhub.com', 'will@therapyanimalhub.com'],
  },
  EMAIL: {
    NO_REPLY: `TAH Bot 🤖 <noreply@therapyanimalhub.com>`,
    SUPPORT: 'contact@therapyanimalhub.com',
    WEB_ADMIN: 'chris@chrisesplin.com',
    WILL: 'will@therapyanimalhub.com',
  },
  PHONE: {
    SUPPORT: '+14153235581',
    ON_CALL: '+18016738585',
  },
  FEATURES: {
    /**
     * Require a verified email before checkout can complete. Off by default: it adds a
     * step to the funnel, and the typo hint plus normalization may already have closed the
     * gap. Flip via the env var in Render, no code change.
     *
     * Before flipping, read the current typo rate with `npm run email:triage`. If new
     * accounts have stopped acquiring typos, leave this off.
     */
    REQUIRE_VERIFIED_EMAIL_AT_CHECKOUT: process.env.REQUIRE_VERIFIED_EMAIL_AT_CHECKOUT === 'true',
  },
  ENV: {
    AUTH_SECRET: process.env.AUTH_SECRET!,
    CRON_SECRET: process.env.CRON_SECRET ?? '',
    FIREBASE_WEB_PUSH_PUBLIC_KEY: process.env.NEXT_PUBLIC_FIREBASE_WEB_PUSH_PUBLIC_KEY!,
    IS_BUILD: process.env.IS_BUILD || false,
    IS_SECURE: !!process.env.AUTH_URL?.includes('therapyanimalhub.com'),
    IS_PRODUCTION: !!process.env.STRIPE_SK?.includes('live'),
    ORIGIN: process.env.AUTH_URL!,
    PGPASSWORD: process.env.PGPASSWORD!,
    RESEND_API_KEY: process.env.AUTH_RESEND_KEY!,
    SENDGRID_API_KEY: process.env.SENDGRID_API_KEY!,
    SENDGRID_VERIFICATION_KEY: process.env.SENDGRID_VERIFICATION_KEY ?? '',
    // Needs `suppressions.read`, which SENDGRID_API_KEY does not carry. Unset means the
    // suppression check falls back to our own recorded events.
    SENDGRID_SUPPRESSION_API_KEY: process.env.SENDGRID_SUPPRESSION_API_KEY ?? '',
    STRIPE_COUPON_ID: process.env.STRIPE_COUPON_ID!,
    STRIPE_PARTNER_REDIRECT_URL: process.env.STRIPE_PARTNER_REDIRECT_URL ?? '',
    STRIPE_PK: process.env.NEXT_PUBLIC_STRIPE_PK!,
    STRIPE_SK: process.env.STRIPE_SK!,
    STRIPE_WEBHOOK_SECRET: process.env.STRIPE_WEBHOOK_SECRET ?? '',
    STRIPE_CONNECT_WEBHOOK_SECRET: process.env.STRIPE_CONNECT_WEBHOOK_SECRET ?? '',
    TURSO_AUTH_TOKEN: process.env.TURSO_AUTH_TOKEN!,
    TURSO_ENCRYPTION_KEY: process.env.TURSO_ENCRYPTION_KEY,
    TURSO_SYNC_URL: process.env.TURSO_SYNC_URL!,
    INTERCOM_SECRET: process.env.INTERCOM_SECRET ?? '',
    POSTGRES_DATABASE_URL: process.env.POSTGRES_DATABASE_URL!,
    SUPPORT_API_KEY: process.env.SUPPORT_API_KEY ?? '',
    TURSO_URL: process.env.TURSO_URL!,
    TWILIO_ACCOUNT_SID: process.env.TWILIO_ACCOUNT_SID!,
    TWILIO_AUTH_TOKEN: process.env.TWILIO_AUTH_TOKEN ?? '',
    TWILIO_PHONE: process.env.NEXT_PUBLIC_TWILIO_PHONE!,
    TWILIO_SECRET: process.env.TWILIO_SECRET!,
    TWILIO_SID: process.env.TWILIO_SID!,
    SEND_DEBUG_EMAILS: false,
  },
  SUPPORTED_STATES: quizJson.find((q) => q.key === 'state')?.answers?.map((a) => a.toLowerCase()) || [],
  FIFTY_STATES: [
    'Arizona',
    'Alabama',
    'Alaska',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ],
};
